/**
 * @file calling card
 * @author zhaomiaoyuan
 */
import React from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import './index.less';
const CallingCard = (props) => {
    const {
        data,
        rewrite
    } = props;
    return (
        <div>
            <ul className="calling-card">
                <li>{data.phone}</li>
                {data.phoneName && <li>{data.phoneName}</li>}
            </ul>
            <p className="rewrite">
                不是该号码？
                <span onClick={rewrite}>
                    重新输入
                </span>
            </p>
        </div>
    );
};

CallingCard.propTypes = {
    data: PropTypes.object,
    rewrite: PropTypes.func
};

export default withRouter(CallingCard);
